/* Lightweight confetti celebration — fires on free-shipping unlock + gift claim. No library. */
(function () {
  window.dgdConfetti = function () {
    try { if (matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
    var wrap = document.createElement('div');
    wrap.className = 'dgd-confetti';
    var colors = ['#2C7BE5', '#E4002B', '#19B364', '#FFC400'];
    for (var i = 0; i < 40; i++) {
      var p = document.createElement('i');
      p.style.left = (Math.random() * 100) + '%';
      p.style.background = colors[i % colors.length];
      p.style.animationDuration = (1 + Math.random() * 1.3) + 's';
      p.style.animationDelay = (Math.random() * 0.25) + 's';
      p.style.transform = 'rotate(' + (Math.random() * 360) + 'deg)';
      wrap.appendChild(p);
    }
    document.body.appendChild(wrap);
    setTimeout(function () { wrap.remove(); }, 2800);
  };
  // Free-shipping unlock: celebrate once per crossing (per session)
  function checkShip() {
    var complete = !!document.querySelector('.free-shipping.is-complete');
    var flagged = sessionStorage.getItem('dgd_ship_celebrated') === '1';
    if (complete && !flagged) { sessionStorage.setItem('dgd_ship_celebrated', '1'); window.dgdConfetti(); }
    else if (!complete && flagged) { sessionStorage.removeItem('dgd_ship_celebrated'); }
  }
  document.addEventListener('cart-drawer:open', function () { setTimeout(checkShip, 80); });
  document.addEventListener('cart:refresh', function () { setTimeout(checkShip, 1000); });
})();
